/* Input Form Styles */

:host {
  font-family: var(--ai12z-font-family) !important;
  font-size: var(--ai12z-font-size) !important;
}
.input-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
}
.input-container {
  margin-right: 1rem;
  position: relative;
  /* border-radius: 0.375rem; */
  border-radius: 4rem;
  border-width: 1px;
  align-items: stretch;
  display: flex;
  /* height:150px; */
}

.inner-container {
  flex-grow: 1;
  padding: 0.75rem;
}

.custom-input {
  display: block;
  /* width: 100%; */
  border-width: 0;
  max-height: 300px;
  resize: none;
  overflow: hidden;
  background-color: inherit;
}

.custom-input::placeholder {
  color: var(--ai12z-input-placeholder-color);
  opacity: 1; /* Firefox */
  font-size: var(--ai12z-input-placeholder-font-size);
}

.custom-input:focus {
  outline: none;
  box-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--ai12z-border-color);
}

.input-focus-color {
  border-color: rgb(59 130 246) !important;
}

.plus-icon {
  /* fill: var(--ai12z-plus-icon-color); */
  color: var(--ai12z-plus-icon-color);
}
.ai-button {
  border-left-width: 1px;
  padding-left: 1rem;
  padding-right: 1rem;
  white-space: nowrap;
  display: inline-flex;
  place-items: center;
  color: var(--ai12z-button-font-color);
  font-size: var(--ai12z-button-font-size);
  /* min-width: 90px; */
}

.ai-button:hover {
  background-color: var(--ai12z-hover-button-color);
  color: rgb(255 255 255);
}

.follow-up {
  display: flex;
  gap: 0.5rem;
  color: var(--ai12z-followup-color);
  font-size: var(--ai12z-followup-font-size);
}

.follow-up-input {
  appearance: none;
  width: 1rem;
  height: 1rem;
  border-width: 2px;
  flex-shrink: 0;
  margin-top: 0.25rem;
  border-radius: 0.125rem;
  border-color: rgb(59 130 246);
}

.follow-up-input:checked {
  background-color: var(--ai12z-followup-bg-color);
  border-width: 0px;
}

.custom-svg-checkbox {
  margin-top: 0.25rem;
  width: 1rem;
  height: 1rem;
  position: absolute;
}

.hide-svg {
  display: none;
}

.icon-width {
  width: 1.75rem;
}

.custom-attachment {
  border-right-width: 1px;
  padding-top: 10px;
  padding-left: 1rem;
  padding-right: 2rem;
  cursor: pointer;
  width: 5%;
}

#fileInput {
  display: none;
}

.error-msg {
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  text-align: center;
}

.image-Container {
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.delete-image {
  opacity: 3;
  position: absolute;
  right: 3px;
  top: 0;
  cursor: pointer;
  line-height: 10px;
}

.btn-bg-color {
  background-color: var(--ai12z-button-bgcolor);
}

.searchbar-bgcolor {
  background-color: var(--ai12z-searchbar-bgcolor);
}

.inline-searchbar-bgcolor {
  border-color: var(--ai12z-inlinesearchbar-border-color);
  background-color: var(--ai12z-inlinesearchbar-bgcolor);
  border-width: 1px;
}
